import {inject, Pipe, PipeTransform} from '@angular/core';
import {PatientManagementService} from '../patient-management.service';

@Pipe({
  name: 'locationName'
})
export class LocationNamePipe implements PipeTransform {
  patientManagementService: PatientManagementService = inject(PatientManagementService);

  transform(locationId: number): string | undefined {
    return this.patientManagementService.locationDetailDtos?.find(l => l.locationId == locationId)?.name;
  }
}
